import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom"
import ScrollToTop from "./ScrollToTop";
import WhatsappFloat from "./WhatsappFloat";
import ReviewFloat from "./ReviewFloat";

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Scroll Fix */}
   <ScrollToTop />  

      {/* Header */}
      <Header />

      {/* Main content */}
      <main className="flex-grow pt-16">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />


      {/* Floating WhatsApp Button */}
      <WhatsappFloat />


{/* Review Video Button */}
<ReviewFloat />
    </div>
  );
};

export default Layout;
